const base = {
  color: {
    base1: '#3e3b41',
    base2: '#707070',
    base3: '#bbbbbb',
    border: '#e6e6e6',
    success: '#1fa100',
    failure: '#ff0000',
    white: '#ffffff',
    black: '#000000',
    green: '#4caf50',
    warning: '#ff9800',
    notification: '#FF632D',
    positive: '#74C400',
    negative: '#d24545',
    under: '#dec03f',
    gold: '#E3BA4C',
    skyBlue: '#003f67',
    nightBlue: '#051629',
    main: '#0b223d',
    darkGreyBlue: '#303d58',
    dusk: '#546086',
    cloudyBlue: '#a8b3d3',
    terraCotta: '#d7622b',
    dullOrange: '#e3762f',
    dustyOrange: '#f29436',
    apricot: '#f8bd67',
    lightPeach: '#fed2af',
    beige: '#fcd395',
    iceBlue: '#f8f9f9',
    veryLightBlue: '#e6eaef',
    paleSkyBlue: '#d6dee4',
    lightGreyBlue: '#a4abb7',
    gunmetal: '#4d4f54',
    black30: 'rgba(0, 0, 0, 0.3)',
    rouge: '#be1e2d',
    mossyGreen: '#539425',
    greyishBrown: '#3f3f3f',
    black50: 'rgba(0, 0, 0, 0.5)',
    brownGrey: '#9e9e9e',
    grey7: '#757575',
    grey8: '#616161',
    grey9: '#424242',
    veryLightPink: '#eeeeee'
  },

  size: {
    '1': '18',
    '2': '16',
    '3': '14',
    '4': '12',
    '5': '10'
  },

  font: {
    light: 'noto-sans-light',
    default: 'noto-sans-regular',
    medium: 'noto-sans-medium',
    bold: 'noto-sans-bold'
  },

  boxShadow: {
    '1': '0px 6px 10px 0px rgba(0, 0, 0, 0.15)',
    '2': '0 -3px 5px -1px rgba(0, 0, 0, .2)',
    '3': '0 3px 5px -1px rgba(0, 0, 0, .15)',
    filter: '0px 3px 8px -1px rgba(0, 0, 0, 0.2)'
  }
};

export default base;



// WEBPACK FOOTER //
// ./src/themes/themes/Base.js